import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 10/13;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 10 13" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Docs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Doc" transform="translate(-437.000000, -365.000000)">
                <g id="Group-10" transform="translate(421.000000, 180.000000)">
                    <g id="Group-7" transform="translate(11.000000, 182.000000)">
                        <g id="Underline" transform="translate(5.000000, 0.000000)">
                            <path d="M2.44042969,3.13574219 L2.44042969,9.40429688 C2.44042969,10.8125 3.32910156,11.8037109 4.90136719,11.8037109 C6.47363281,11.8037109 7.36914062,10.8125 7.36914062,9.40429688 L7.36914062,3.13574219 L8.89355469,3.13574219 L8.89355469,9.53417969 C8.89355469,11.6601562 7.37597656,13.1640625 4.90136719,13.1640625 C2.42675781,13.1640625 0.909179688,11.6601562 0.909179688,9.53417969 L0.909179688,3.13574219 L2.44042969,3.13574219 Z" id="U" fill={color}></path>
                            <path d="M1,15.5 L9,15.5" id="Line-7" stroke="#02BDAD" strokeLinecap="square"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconFormatUnderline extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
